export default __webpack_public_path__ + "static/media/careGreyHollow.ddc47bbb.svg";